import { buildFetchScheduledPostsReducer } from './scheduledPosts.reducer';

export const fetchScheduledCommonRoomReducer =
  buildFetchScheduledPostsReducer('scheduledPosts');

export const fetchScheduledAnnouncementsReducer =
  buildFetchScheduledPostsReducer('scheduledAnnouncements');
